export default{
  "foot": {
    "title": "Người chơi Century Games",
    "p1": "Sau khi nhập ID trò chơi, bạn có thể chọn sản phẩm để mua. Nếu khoản tiền chưa cập nhật vào tài khoản, bạn có thể thử khởi động lại trò chơi, hoặc liên hệ với CSKH.",
    "p2": "Nếu bạn có bất kỳ thắc mắc nào, vui lòng liên hệ với CSKH, xin cảm ơn sự ủng hộ của bạn!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Điều khoản dịch vụ",
    "policy": "Chinh sách quyền riêng tư",
    "descriptionTitle": "Hệ thống này như thế nào?"
  },
  "accept": {
    "title": "Chúng tôi sử dụng các cookies cần thiết để cung cấp địch vụ và cải thiện trải nghiệm của bạn, để biết thêm các thông tin liên quan, xin vui lòng tham khảo <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Chính sách quyền riêng tư</a> của chúng tôi.",
    "decline": "Từ chối",
    "accept": "Đồng ý"
  },
  "game": {
    "inapptext": "Hoặc đăng nhập qua trò chơi",
    "loginfail": "Đăng nhập thất bại",
    "logintip": "Nếu ủy quyền không thành công, vui lòng cập nhật ứng dụng trò chơi lên phiên bản mới nhất, hoặc thử các trình duyệt khác để truy cập trang web.",
    "reloadmsg": "Vui lòng bấm \"Tải lại\" để nhận kết quả đăng nhập",
    "reload": "Tải lại",
    "appnotice": "Nếu bạn mốn đăng nhập qua trò chơi, vui lòng sử dụng trình duyệt bên ngoài để truy cập trang web",
    "changeaccount": "Bạn chắc chắn muốn đăng xuất không?",
    "login": "Đăng nhập",
    "notice": "Thông báo",
    "confirm": "Xác nhận",
    "loginuserid": "ID User",
    "palceholder": "Nhập ID User",
    "okbtn": "OK",
    "loginbtn": "Đăng nhập qua trò chơi",
    "changebtn": "Hoặc đăng nhập bằng ID User",
    "useTitle": "TÀI KHOẢN",
    "checkBtn": "Xác nhận",
    "findid": "Không tìm thấy ID User của bạn?",
    "checktext": "ID User thường tìm thấy trong Cài đặt, bạn có thể bấm vào biểu tượng dấu chấm hỏi để biết thêm thông tin.",
    "username": "Nickname:",
    "userId": "ID User:",
    "packageTitle": "Chọn sản phẩm",
    "edit": "Sửa",
    "paymentTitle": "Phương thức thanh toán",
    "total": "Tổng giá trị",
    "goPay": "Thanh toán",
    "noSelectPackageTips": "Vui lòng chọn sản phẩm",
    "payFail": "THANH TOÁN THẤT BẠI",
    "camelPayfail": "Thanh toán tất bại",
    "payFailTips1": "Vui lòng liên hệ với CSKH Adyen để được hỗ trợ",
    "payFailTips2": "Vui lòng liên hệ với CSKH Paypal để được hỗ trợ",
    "paySuccess": "THANH TOÁN THÀNH CÔNG",
    "paySuccessTips2": "Nếu sản phẩm chưa vào tài khoản, vui lòng khởi động lại trò chơi hoặc liên hệ với CSKH",
    "camelPaySuccess": "Thanh toán thành công",
    "transactionId": "ID đơn hàng",
    "paySuccessTips": "Việc giao hàng có thể mất chút thời gian, xin vui lòng đợi.",
    "deliveryFail": "Vận chuyển sản phẩm thất bại",
    "deliveryFailTips": "Vui lòng liên hệ với CSKH trong trò chơi để được hỗ trợ",
    "orderTitle": "Thông tin đơn hang",
    "paidWith": "Phương thức thanh toán",
    "orderID": "ID đơn hàng",
    "payStatus": "Trạng thái thanh toán",
    "orderTotal": "Tổng giá trị",
    "transactionDate": "Thời gian đặt hàng",
    "goOnPay": "Mua lại",
    "getInvoice": "Hóa đơn thanh toán",
    "camelDeliveryFail": "Giao hàng thất bại",
    "confirmOrder": "Xác nhận đơn hàng",
    "confirmFollow": "Vui lòng xác nhận các thông tin sau:",
    "nickname": "Nickname",
    "packageName": "Sản phẩm",
    "totalPayment": "Tổng giá trị",
    "confirmPayWith": "Phương thức thanh toán",
    "confirmAndGoOn": "Xác nhận và thanh toán",
    "orderCancel": "Hủy",
    "getInvoiceTitle": "GỬI QUA EMAIL",
    "getInvoiceTips": "Vui lòng cung cấp địa chỉ email nếu bạn muốn nhận hóa đơn qua emal.",
    "getInvoiceTips1": "Vui lòng nhập hộp thư của bạn",
    "getInvoiceTips2": "Đồng ý cho chúng tôi thu thập và lữu trữ địa chỉ email của bạn",
    "getInvoiceTips3": "Đồng ý nhận email về giảm giá, khuyến mãi và nhiều thông tin khác trong trò chơi",
    "invoiceSend": "Gửi",
    "sendSuccess": "Gửi thành công",
    "id404": "Không tìm thấy ID User",
    "packageLoadingText": "Sản phẩm đang được cập nhật..",
    "taxTips": "Giá bao gồm thuế",
    "adyenTips": "Dịch vụ thanh toán được cung cấp bởi Adyen - công ty hoạt động theo giấy phép ngân hàng, và được giám sát bởi Ngân hàng Trung ương Hà Lan. Nếu bạn có bất kỳ thắc mắc nào, vui lòng tham khảo tại <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Để biết thêm về chính sách bảo vệ dữ liệu người dùng, vui lòng tham khảo tại <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "Dịch vụ thanh toán được cung cấp bởi PayPal, để biết thêm về chính sách bảo vệ dữ liệu người dùng, vui lòng tham khảo tại <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>.",
    "switchCountryTips": "Quốc gia/Khu vực thông thường của bạn là ${servercountry}, bạn có muốn đổi quốc gia và loại tiền tệ?",
    "paypalBtn": "Thanh toán bằng Thẻ ngân hàng",
    "paypalOr": "Hoặc",
    "paypalCard1": "Tên chủ thẻ (Tùy chọn)",
    "paypalCard2": "Số thẻ",
    "checkUserID": "Liên kết",
    "success": "THÀNH CÔNG",
    "changeCurrencyContent": "Bạn có muốn chuyển đổi khu vực và đơn vị tiền tệ để phù hợp với cài đặt trong game của bạn: ${servercountry} không？",
    "productDescription": "Ngôi Sao Băng Giá là đồng tiền có được sau khi thanh toán bằng tiền mặt, dùng để mua các gói quà và vật phẩm ưu đãi trong trò chơi.",
    "payButton": "THANH TOÁN",
    "userIdNotice": "Trước tiên vui lòng nhập ID User của bạn để liên kết với tài khoản game của bạn",
    "account": "Tài khoản",
    "card": "Thẻ",
    "notification": "Nhập User ID của bạn để liên kết với tài khoản của bạn, chọn các vật phẩm mong muốn sau đó thanh toán bằng phương thức thanh toán ưa thích của bạn. Sau khi tải lại trò chơi, các vật phẩm đã mua sẽ được hiển thị trong tài khoản của bạn và sẵn sàng để sử dụng.\n\nNếu bạn có bất kỳ thắc mắc nào, xin vui lòng liên hệ với CSKH trong trò chơi.",
    "rongluRank": "Level Lò Lửa:",
    "tips": "Sử dụng ra sao?",
    "checkTIps1": "Tôi đã đọc hiểu và đồng ý với <a :href=\"policyUrl\">\"Chính sách quyền riêng tư\"</a>、<a :href=\"serviceURl\">\"Thoả thuận dịch vụ\"</a> và <a :href=\"paymentURl\">\"Điều khoản thanh toán\"</a>.",
    "checkTIps2": "Vui lòng đọc và tick chọn",
    "selectTips": "(Trang web sẽ tự động chọn đơn vị tiền tệ bạn đã sử dụng gần nhất để nạp tiền trong game)",
    "koPayTips": "*Nếu thẻ ngân hàng của bạn sử dụng đồng Won Hàn Quốc như một ngoại tệ, Dịch vụ Chuyển đổi tiền tệ linh động (DCC) sẽ được sử dụng và phụ phí xử lý có thể bị thu bởi proxy bên thứ ba, không phải bởi website này."
  },
  "invoice": {
    "title": "Hóa đơn thanh toán",
    "transactionId": "ID đơn hàng",
    "transactionDate": "Thời gian đặt hàng",
    "totalAmount": "Tổng cộng",
    "paymentMethod": "Phương thức thanh toán",
    "description": "Mô tả",
    "game": "Trò chơi",
    "quantity": "Số lượng",
    "price": "Giá",
    "amount": "Giá trị",
    "total": "Tổng cộng",
    "footTitle": "Ghi chú",
    "footContent": "Cảm ơn bạn đã ủng hộ Century Games!",
    "button1": "Nhận hoá đơn",
    "button2": "Quay lại mà không cần biên lai",
    "giveupInvoice": "Bạn sẽ không nhận được hoá đơn cho đơn hàng này. Bạn xác nhận không cần hoá đơn?"
  },
  "payment": {
    "card": "Thẻ credit/Thẻ debit",
    "paypal": "Paypal"
  },
  "country": {
    "countryTitle1": "QUỐC GIA/KHU VỰC",
    "Africa": "Châu Phi",
    "America": "Châu Mỹ",
    "Asia": "Châu Á",
    "Europe": "Châu Âu",
    "Oceania": "Châu Đại Dương",
    "ZA": "Nam Phi",
    "US": "Hoa Kỳ",
    "HK": "Hồng Kông, Trung Quốc",
    "JP": "Nhật Bản",
    "KR": "Hoa Kỳ",
    "SG": "Singapore",
    "SA": "Ả Rập Xê Út",
    "IQ": "Iraq",
    "TW": "Đài Loan, Trung Quốc",
    "TH": "Thái Lan",
    "GB": "Vương quốc Anh",
    "AU": "Úc",
    "countryLanguage1": "NGÔN NGỮ",
    "AE": "Các tiểu vương quốc Ả Rập thống nhất",
    "DE": "Đức",
    "PT": "Bồ Đào Nha",
    "RU": "Nga",
    "ES": "Tây Ba Nha",
    "CH": "Thuỵ Sĩ",
    "TR": "Thổ Nhĩ Kỳ",
    "KW": "Cô-oét",
    "QA": "Qatar",
    "PL": "Ba Lan",
    "ID": "Indonesia",
    "IT": "Ý",
    "IN": "Ấn Độ",
    "FR": "Pháp",
    "CA": "Gia nả đại",
    "NL": "Hà Lan",
    "AT": "Áo",
    "RS": "Xéc-bi",
    "SE": "Thụy Điển",
    "MY": "Mã Lai",
    "BE": "nước Bỉ",
    "DK": "Đan Mạch",
    "FI": "Phần Lan",
    "PH": "nước Philippines",
    "NO": "Na Uy",
    "BR": "Bờ-ra-zin",
    "NZ": "quần đảo Tân tây lan",
    "UA": "nước Ukraine",
    "RO": "România"
  },
  "extra_info": {
    "kingdom": "Quốc gia:"
  },
  "adyen": {
    "note": "Dịch vụ thanh toán này được cung cấp bởi Adyen, mang đến cho bạn dịch vụ thanh toán thẻ tín dụng trong nước và quốc tế an toàn với chứng nhận PCI-DSS cấp cao nhất của Tổ chức Thẻ tín dụng quốc tế.",
    "note2": "Lưu ý: chọn “Lưu để thuận tiện cho các lần thanh toán sau này”. Chỉ lưu thông tin thẻ tín dụng cá nhân trên trình duyệt hiện tại."
  },
  "pay": {
    "error1": "Nếu xảy ra lỗi với khoản thanh toán hiện tại, vui lòng thử lại sau hoặc thay đổi phương thức thanh toán. Nếu bạn có bất kỳ thắc mắc nào, vui lòng liên hệ với CSKH."
  }
}


// WEBPACK FOOTER //
// ./src/lang/VI.js